// ================================================================
//  <bm-user> — one shared person-icon + user identity renderer, for
//  every "who" reading in the app (created by / updated by / assigned
//  to / notification recipient / service account owner / ...).
//
//  Consolidates what used to be a dozen independently-hand-rolled
//  "name only", "name + email", or "email + separate name column"
//  layouts — now there is exactly one visual shape (person icon, name,
//  and a muted ID · email line underneath) and one place that decides
//  how a user ID gets shortened, so identity reads the same everywhere.
//
//  Usage:
//    <bm-user name="user.firstName + ' ' + user.lastName"
//             user-id="user.id" email="user.email">
//    </bm-user>
//
//    <!-- Compact — no padding/background, just icon + name, for a
//         tight table cell or an inline "by {name}" caption. -->
//    <bm-user name="e.createdBy" compact="true"></bm-user>
//
//  Bindings:
//    name    ('<') display name — or null/undefined, which renders
//            emptyText instead of a blank line.
//    userId  ('<') full user ID (e.g. a UUID). Shown shortened to its
//            last 10 characters, uppercased (same convention as the
//            Users tab's own getShortId) — never the raw ID.
//    email   ('<') email address.
//    label   ('@') optional caption under the meta line — ignored in
//            compact mode.
//    variant ('@') 'neutral' (default) | 'success' | 'warning' | 'danger'.
//    compact   ('<') boolean — strips padding/background/border and the
//              ID/email meta line, for table cells and other tight spaces.
//    emptyText ('@') shown in place of the name when missing — defaults
//              to 'Unknown'.
// ================================================================

angular.module('bizmetryApp').component('bmUser', {
  bindings: {
    name: '<',
    userId: '<',
    email: '<',
    label: '@',
    variant: '@',
    compact: '<',
    emptyText: '@'
  },
  template: `
    <span class="bm-user"
          title="{{ $ctrl.compact ? ($ctrl.name || '') : '' }}"
          ng-class="['bm-user--' + ($ctrl.variant || 'neutral'), $ctrl.compact ? 'bm-user--compact' : '']">
      <md-icon class="bm-user-icon">person</md-icon>
      <span class="bm-user-text">
        <span class="bm-user-name">{{ $ctrl.name || $ctrl.emptyText || 'Unknown' }}</span>
        <span class="bm-user-meta" ng-if="!$ctrl.compact && ($ctrl.shortId() || $ctrl.email)">
          <span class="bm-user-id" ng-if="$ctrl.shortId()">{{ $ctrl.shortId() }}</span>
          <span class="bm-user-sep" ng-if="$ctrl.shortId() && $ctrl.email">&middot;</span>
          <span class="bm-user-email" ng-if="$ctrl.email">{{ $ctrl.email }}</span>
        </span>
        <span class="bm-user-label" ng-if="$ctrl.label && !$ctrl.compact">{{ $ctrl.label }}</span>
      </span>
    </span>
  `,
  controller: function () {
    var vm = this;
    // Last 10 characters of the ID (dashes stripped), uppercased — the
    // same shortening rule the Users tab already used, now centralized.
    vm.shortId = function () {
      if (!vm.userId) { return null; }
      var stripped = String(vm.userId).replace(/-/g, '');
      return stripped.slice(-10).toUpperCase();
    };
  }
});
